import styled from 'styled-components';
import { Row, Col, Radio } from 'antd';

interface CardScoreProps {
	$isSelected: boolean;
}

export const Container = styled(Row)`
	border-radius: 12px;
	padding: 1.5rem 2rem 2rem;
	background-color: #f8f8f8;
`;

export const RadioGroup = styled(Radio.Group)`
	width: 100%;

	.ant-radio-button-wrapper {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 1rem;
		width: 10rem;
		height: 13rem;
		color: #262626 !important;
		border: 2px solid #d9d9d9;
		background-color: #ffffff;
		text-align: center !important;
		border-radius: 20px !important;

		svg {
			width: 5rem;
			height: 5rem;
		}

		.ant-typography {
			font-size: 0.8rem;
		}

		.lower_limbs {
			width: 4rem;
			height: 4rem;
		}

		@media (min-width: 1200px) {
			padding: 1.2rem;
		}

		@media (min-width: 1600px) {
			width: 13rem;
			height: 15rem;
			padding: 1.7rem;

			svg {
				width: 7rem;
				height: 7rem;
			}

			.ant-typography {
				font-size: 1rem;
			}

			.lower_limbs {
				width: 5rem;
				height: 5rem;
			}
		}
	}

	.ant-radio-button-checked {
		background-color: #eaeefd;
		border-radius: 20px !important;
	}

	.ant-radio-button-wrapper {
		line-height: 24px !important;
	}
`;

export const CardContainer = styled(Col)`
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const CardScore = styled(Col)<CardScoreProps>`
	position: absolute;
	top: 5%;
	right: 5%;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 22px;
	height: 22px;
	border-radius: 6px;
	background-color: ${({ $isSelected }) => ($isSelected ? '#2F54EB' : '#b3b3b3')};

	span {
		color: #ffffff;
		font-size: 1rem;
	}
`;
